<template>
	<el-row>
		<el-button type="primary" plain @click="add">+添加</el-button>
		<el-table :data="tableData" style="margin-top: 20px;" row-key="id"
			:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
			<el-table-column label="序号" prop="id"></el-table-column>
			<el-table-column prop="name" label="公告名称"></el-table-column>
			<el-table-column label="发布时间" prop="created"></el-table-column>
			<el-table-column label="状态" prop="status">
				<template slot-scope="scope">
					<el-switch :active-value="0" :inactive-value="1" @change="isStatus(scope.row)" active-text="正常"
						inactive-text="禁用" v-model="scope.row.status">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="del(scope.row)" style="color: red;">删除</el-button>
					<el-button type="text" @click="bianji(scope.row)" style="color: #00cc33;">编辑公告</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				info: {
					value: "",
					num: ''
				},
				tableData: [],
				name: '',
				total: 0,
				pageNum: 1,
				pageSize: 30,
				pagelist: [30, 50, 100]
			}
		},
		methods: {
			del(row) {
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/course/ClrNoticeManageController/edit`, {
						"id": row.id,
						"deleteStatus": 1
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.getInfo()
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			add() {
				this.$router.push({
					path: './addnotice',
					query: {
						cz: 'tj'
					}
				})
			},
			bianji(row) {
				this.$router.push({
					path: './addnotice',
					query: {
						"cz": 'bj',
						"id": row.id,
						"name": row.name,
						"describes": row.describes,
					}
				})
			},
			isStatus(row) {
				console.log(row);
				this.$http.post(`/api/course/ClrNoticeManageController/edit`, {
					"id": row.id,
					"status": row.status == 0 ? 0 : 1
				}).then(res => {
					this.getInfo()
				})
			},
			getInfo() {
				this.$http.get(
					`/api/course/ClrNoticeManageController/selectList?name=${this.name}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`, {}
				).then(res => {
					console.log(res.data.data);
					this.total = res.data.data.total
					this.tableData = res.data.data.list
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			}
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">
	/deep/.el-input-number__increase {
		right: -38px;
	}
</style>
